import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ProviderData } from '../providers.interface';
import { OptionItem } from '../../../shared/types/api-responses.type';
import { MasterProviderFormValidations } from './provider-form-validations';
import { ProvidersService } from '../../../services/providers/providers.service';
import { firstValueFrom } from 'rxjs';
import { showAlert } from '../../../shared/helpers/alert'; 

@Component({
  selector: 'app-provider-form',
  templateUrl: './provider-form.component.html',
  styleUrls: ['./provider-form.component.css']
})
export class ProviderFormComponent implements OnInit {
  loading: boolean = false;
  form!: FormGroup;
  readonly id: string;
  providerData!: ProviderData;
  roles: OptionItem[] = [];
  isChangePassword = false;
  readonly MasterProviderFormValidations = MasterProviderFormValidations;



  constructor(
    private readonly fb: FormBuilder,
    private readonly route: ActivatedRoute,
    private readonly providerService: ProvidersService,
    private readonly router: Router
  ) {
    this.id = this.route.snapshot.paramMap.get('id') ?? '';

    
 
  }

  async ngOnInit(): Promise<void> {
    this.initForm();
    await this.loadInitialData();
  }

  private initForm(): void {
    this.form = this.fb.group({
      
      id: [''],
      code: [''],
      name: [''],
      user: [''],
      password: [''],
      secret_code: [''],
      base_url: [''],
      method: [''],
      inq_param: [''], // Initialize it as a Date object
      pay_param: [''],
      adv_param: [''],
      reversal_param: [''],
      inq_url: [''],
      pay_url: [''],
      adv_url: [''],
      reversal_url: [''],
      callback_url:[''],
 
    });

    this.form.valueChanges.subscribe(value => console.log('Form Value Changed:', value));
  }

   

  private async loadInitialData(): Promise<void> {
    this.loading = true;
    try {
    
      if (this.id) {
        await this.getProviderData();
      }
      
    } catch (error) {
      console.error('Error loading initial data:', error);
      this.showNotification('error', 'Error', 'Failed to load some initial data.');
    } finally {
      this.loading = false;
    }
  }

  private async getProviderData(): Promise<void> {
    try {
      const { data } = await firstValueFrom(this.providerService.getProviderById(this.id));
      this.providerData = data;
      this.patchProviderData(data);
    } catch (error) {
      this.showNotification('error', 'Failed to fetch provider', JSON.stringify(error));
    }
  }

  private patchProviderData(provider: ProviderData): void {
    console.log('Patching Provider Data:', provider);
    console.log('Form Controls Before Patch:', this.form.controls);
 

    this.form.patchValue({
      id: provider.id || '',
      name: provider.name || '',
      user: provider.user || '',
      password: provider.password || '',
      secret_code: provider.secret_code || '',
      base_url: provider.base_url || '',
      method: provider.method || '',
      inq_param: provider.inq_param || '',
      pay_param: provider.pay_param || '',
      adv_param: provider.adv_param || '',
      reversal_param: provider.reversal_param || '',
      inq_url: provider.inq_url || '',
      pay_url: provider.pay_url || '',
      adv_url: provider.adv_url || '',
      reversal_url: provider.reversal_url || '',
      code: provider.code || '',
      callback_url: provider.callback_url || ''
      
    });
    

    console.log('Form Value After Patch:', this.form.value);

     
  }

  convertToFlatpickrDate(dateString: string): string {
    if (!dateString) return '';
  
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      console.error('Invalid date format:', dateString);
      return '';
    }
  
    return [
      date.getDate().toString().padStart(2, "0"),
      (date.getMonth() + 1).toString().padStart(2, "0"),
      date.getFullYear()
    ].join("/");
  }


  async saveData(): Promise<void> {
    console.log('Form value before saving:', this.form.value);


    if (this.id) {
        await this.updateProvider();
        return;
    }
    await this.createProvider();
}


  async createProvider(): Promise<void> {
    this.loading = true;
    try {
      const resp = await firstValueFrom(this.providerService.createProvider(this.form.value));

      if (resp.code === 0) {
        this.showNotification('success', 'Success', 'Provider created successfully');
        await this.router.navigate(['/providers/list']);
      } else {
        this.showNotification('error', 'Error', 'Failed to create provider');
      }
    } catch (error) {
      this.showNotification('error', 'Error', JSON.stringify(error));
    } finally {
      this.loading = false;
    }
  }

  async updateProvider(): Promise<void> {
    this.loading = true;
    try {
      const resp = await firstValueFrom(this.providerService.updateProvider(this.id, this.form.value));

      if (resp.code === 0) {
        this.showNotification('success', 'Success', 'Provider updated successfully');
        await this.router.navigate(['/providers/list']);
      } else {
        this.showNotification('error', 'Error', 'Failed to update provider');
      }
    } catch (error: any) {
      console.log('Error:', error);
      this.showNotification('error', 'Error', error);
    } finally {
      this.loading = false;
    }
  }
 

  private showNotification(type: 'success' | 'error', title: string, text = 'Success'): void {
    showAlert({ type, title, text }).then();
  }
}
